// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dark-bg: #1a1a2e;
  --card-bg: #252543;
  --accent-purple: #8c6fff;
  --accent-purple-lighter: #9d85ff;
  --accent-purple-darker: #7247ff;
  --text-white: #ffffff;
  --text-light: #e0e0e0;
  --text-muted: #a0a0b0;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.HomeScreen_app-container__Fqevn {
  background-color: var(--dark-bg);
  color: var(--text-white);
  line-height: 1.6;
  background-image: 
      radial-gradient(circle at 10% 20%, rgba(105, 60, 255, 0.05) 0%, transparent 40%),
      radial-gradient(circle at 90% 80%, rgba(140, 111, 255, 0.05) 0%, transparent 40%);
}

.HomeScreen_container__Hzmd0 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header Styles */
header {
  padding: 1.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.HomeScreen_logo__h9zvs {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-white);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.HomeScreen_logo-icon__ElA7K {
  background: linear-gradient(135deg, var(--accent-purple-darker), var(--accent-purple));
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 0 15px rgba(140, 111, 255, 0.3);
}

.HomeScreen_nav-btn__Vi8Sj {
  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));
  color: white;
  font-weight: 600;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.2s;
  border: none;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(140, 111, 255, 0.4);
}

.HomeScreen_nav-btn__Vi8Sj:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 20px rgba(140, 111, 255, 0.6);
}

/* Hero Section */
.HomeScreen_hero__g6a7w {
  padding: 5rem 0 5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.HomeScreen_hero__g6a7w::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at center, rgba(140, 111, 255, 0.03) 0%, transparent 70%);
  z-index: -1;
}

.HomeScreen_hero__g6a7w h1 {
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  background: linear-gradient(135deg, var(--text-white) 0%, #d0c8ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.HomeScreen_hero__g6a7w p {
  font-size: 1.2rem;
  color: var(--text-light);
  max-width: 700px;
  margin: 0 auto 2.5rem;
}

/* Hero Email Form */
.HomeScreen_hero-email-form__Dp37Y {
  max-width: 550px;
  margin: 0 auto 1.5rem;
  display: flex;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 30px rgba(140, 111, 255, 0.15);
}

.HomeScreen_hero-email-input__KCKrg {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  color: white;
  outline: none;
}

.HomeScreen_hero-email-input__KCKrg::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.HomeScreen_hero-submit-btn__A-Vmw {
  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));
  color: white;
  font-weight: 600;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 0 10px rgba(140, 111, 255, 0.3);
}

.HomeScreen_hero-submit-btn__A-Vmw:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 20px rgba(140, 111, 255, 0.5);
}

.HomeScreen_hero-privacy__y67GE {
  font-size: 0.85rem;
  color: var(--text-muted);
}

/* HIPAA Badge */
.HomeScreen_hipaa-badge__0Ln4d {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08));
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 30px;
  padding: 8px 20px;
  margin: 1.5rem auto 0.5rem;
  box-shadow: 0 0 25px rgba(140, 111, 255, 0.5);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.HomeScreen_hipaa-badge-form__0W9hf {
  margin-top: 1.5rem;
}

.HomeScreen_hipaa-badge__0Ln4d:hover {
  box-shadow: 0 0 30px rgba(140, 111, 255, 0.7);
  transform: translateY(-2px);
}

.HomeScreen_hipaa-badge__0Ln4d::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: HomeScreen_shimmer__cOI-2 3s infinite;
}

@keyframes HomeScreen_shimmer__cOI-2 {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.HomeScreen_hipaa-badge-icon__XooAb {
  background: linear-gradient(135deg, var(--accent-purple-darker), var(--accent-purple));
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  box-shadow: 0 0 10px rgba(140, 111, 255, 0.8);
  font-size: 14px;
  font-weight: bold;
  position: relative;
}

.HomeScreen_hipaa-badge-icon__XooAb::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  animation: HomeScreen_pulse__jhb\\+w 2s infinite;
}

.HomeScreen_hipaa-badge-text__Fvv4N {
  font-weight: 600;
  letter-spacing: 0.5px;
  color: white;
  font-size: 0.95rem;
}

/* Feature Cards */
.HomeScreen_features__ARRmd {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
  margin: 4rem 0;
}

.HomeScreen_feature-card__MbAX8 {
  background: linear-gradient(145deg, rgba(40, 40, 80, 0.6), rgba(30, 30, 60, 0.8));
  border-radius: 16px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
}

.HomeScreen_feature-card__MbAX8:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15), 0 0 15px rgba(140, 111, 255, 0.2);
}

.HomeScreen_feature-icon__q9D29 {
  background: linear-gradient(135deg, rgba(140, 111, 255, 0.2), rgba(140, 111, 255, 0.1));
  color: var(--accent-purple-lighter);
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 1.5rem;
  box-shadow: 0 0 20px rgba(140, 111, 255, 0.2);
  position: relative;
}

.HomeScreen_feature-icon__q9D29::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: transparent;
  border: 1px solid rgba(140, 111, 255, 0.3);
  animation: HomeScreen_pulse__jhb\\+w 2s infinite;
}

@keyframes HomeScreen_pulse__jhb\\+w {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  70% {
    transform: scale(1.1);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.HomeScreen_feature-card__MbAX8 h3 {
  font-size: 1.4rem;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, var(--text-white), #d0c8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.HomeScreen_feature-card__MbAX8 p {
  color: var(--text-muted);
  font-size: 1rem;
}

/* Demo Section */
.HomeScreen_demo__SHuwi {
  background: linear-gradient(145deg, rgba(40, 40, 80, 0.6), rgba(30, 30, 60, 0.8));
  border-radius: 20px;
  padding: 3.5rem;
  margin: 5rem 0;
  display: flex;
  align-items: center;
  gap: 3.5rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2), 0 0 20px rgba(140, 111, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.HomeScreen_demo__SHuwi::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 70%;
  height: 70%;
  background: radial-gradient(circle at center, rgba(140, 111, 255, 0.05) 0%, transparent 70%);
  z-index: 0;
}

.HomeScreen_demo-content__c\\+yzC {
  flex: 1 1;
  position: relative;
  z-index: 1;
}

.HomeScreen_demo-content__c\\+yzC h2 {
  font-size: 2.2rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, var(--text-white), #d0c8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.HomeScreen_demo-content__c\\+yzC p {
  color: var(--text-light);
  margin-bottom: 2rem;
}

.HomeScreen_demo-illustration__ZDz5H {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 16px;
  padding: 1.5rem;
  min-height: 340px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
}

.HomeScreen_demo-ui-container__bzlZw {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.HomeScreen_demo-ui-bar__j9NnG {
  background-color: rgba(255,255,255,0.05);
  height: 35px;
  border-radius: 8px;
}

.HomeScreen_demo-ui-content__Z2W8V {
  background-color: rgba(255,255,255,0.02);
  height: 180px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255,255,255,0.3);
}

.HomeScreen_demo-ui-actions__yioFe {
  display: flex;
  justify-content: flex-end;
}

.HomeScreen_demo-ui-button__XGaYD {
  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));
  width: 110px;
  height: 38px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  box-shadow: 0 0 15px rgba(140, 111, 255, 0.4);
}

.HomeScreen_demo-step__6HtkX {
  display: flex;
  margin-bottom: 2rem;
  padding-left: 0.5rem;
}

.HomeScreen_step-number__jKrMs {
  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.2rem;
  font-weight: 600;
  flex-shrink: 0;
  box-shadow: 0 0 15px rgba(140, 111, 255, 0.4);
}

.HomeScreen_demo-step__6HtkX p {
  margin-bottom: 0;
}

/* Email Collection */
.HomeScreen_email-collection__sxGda {
  background: linear-gradient(135deg, #7247ff 0%, #a16bff 100%);
  border-radius: 20px;
  padding: 4rem;
  text-align: center;
  margin: 5rem 0;
  position: relative;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15), 0 0 30px rgba(140, 111, 255, 0.3);
}

.HomeScreen_email-collection__sxGda::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%);
  z-index: 0;
}

.HomeScreen_email-collection__sxGda h2 {
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
}

.HomeScreen_email-collection__sxGda p {
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto 2.5rem;
  font-size: 1.1rem;
  position: relative;
  z-index: 1;
}

.HomeScreen_email-form__qgWEC {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  position: relative;
  z-index: 1;
}

.HomeScreen_email-input__5r59O {
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 1.2rem 1.5rem;
  font-size: 1rem;
  color: white;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.HomeScreen_email-input__5r59O::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.HomeScreen_email-input__5r59O:focus {
  border-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
}

.HomeScreen_submit-btn__CaemG {
  background: white;
  color: var(--accent-purple-darker);
  font-weight: 600;
  padding: 1.2rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
}

.HomeScreen_submit-btn__CaemG:hover {
  transform: translateY(-3px);
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
}

.HomeScreen_privacy-note__Xya45 {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 1rem;
}

/* Testimonials */
.HomeScreen_testimonials__BjIeG {
  margin: 5rem 0;
}

.HomeScreen_testimonials__BjIeG h2 {
  text-align: center;
  font-size: 2.2rem;
  margin-bottom: 3rem;
  background: linear-gradient(135deg, var(--text-white), #d0c8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.HomeScreen_testimonial-card__CvLeQ {
  background: linear-gradient(145deg, rgba(40, 40, 80, 0.6), rgba(30, 30, 60, 0.8));
  border-radius: 16px;
  padding: 2.5rem;
  margin-bottom: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  position: relative;
  overflow: hidden;
}

.HomeScreen_testimonial-card__CvLeQ:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15), 0 0 15px rgba(140, 111, 255, 0.2);
}

.HomeScreen_testimonial-card__CvLeQ::before {
  content: "\\201C";
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 5rem;
  color: rgba(140, 111, 255, 0.1);
  font-family: Georgia, serif;
  line-height: 1;
}

.HomeScreen_testimonial-content__sEWn6 {
  font-size: 1.1rem;
  color: var(--text-light);
  margin-bottom: 1.8rem;
  line-height: 1.8;
  position: relative;
  z-index: 1;
  padding-left: 1rem;
}

.HomeScreen_testimonial-author__RHghx {
  display: flex;
  align-items: center;
}

.HomeScreen_author-avatar__gaow7 {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));
  margin-right: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 15px rgba(140, 111, 255, 0.3);
}

.HomeScreen_author-info__oPkpo h4 {
  font-size: 1.1rem;
  margin-bottom: 0.3rem;
}

.HomeScreen_author-info__oPkpo p {
  font-size: 0.9rem;
  color: var(--text-muted);
}

/* Footer */
footer {
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 2.5rem 0;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
}

/* Glowing button effect */
.HomeScreen_glow-btn__-ckj3 {
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.HomeScreen_glow-btn__-ckj3::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.3) 0%, transparent 80%);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: -1;
  transform: scale(0.5);
}

.HomeScreen_glow-btn__-ckj3:hover::after {
  opacity: 0.3;
  transform: scale(1);
}

/* Responsive */
@media (max-width: 768px) {
  .HomeScreen_hero__g6a7w h1 {
    font-size: 2.2rem;
  }
  
  .HomeScreen_hero-email-form__Dp37Y {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  
  .HomeScreen_hero-submit-btn__A-Vmw {
    width: 100%;
  }
  
  .HomeScreen_demo__SHuwi {
    flex-direction: column;
    padding: 2rem;
  }
  
  .HomeScreen_email-collection__sxGda {
    padding: 2.5rem 1.5rem;
  }
  
  .HomeScreen_feature-card__MbAX8, .HomeScreen_testimonial-card__CvLeQ {
    padding: 2rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/screens/HomeScreen/HomeScreen.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iJAAiJ;AACnJ;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB;;uFAEqF;AACvF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sFAAsF;EACtF,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,uFAAuF;EACvF,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4FAA4F;EAC5F,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uEAAuE;EACvE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uFAAuF;EACvF,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,gDAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,sFAAsF;EACtF,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,+CAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iFAAiF;EACjF,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8EAA8E;AAChF;;AAEA;EACE,uFAAuF;EACvF,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,+CAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,iFAAiF;EACjF,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2CAA2C;EAC3C,6EAA6E;EAC7E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,4FAA4F;EAC5F,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uFAAuF;EACvF,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uFAAuF;EACvF,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6FAA6F;EAC7F,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,+DAA+D;EAC/D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iFAAiF;EACjF,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,2CAA2C;EAC3C,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uFAAuF;EACvF,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2FAA2F;EAC3F,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[":root {\n  --dark-bg: #1a1a2e;\n  --card-bg: #252543;\n  --accent-purple: #8c6fff;\n  --accent-purple-lighter: #9d85ff;\n  --accent-purple-darker: #7247ff;\n  --text-white: #ffffff;\n  --text-light: #e0e0e0;\n  --text-muted: #a0a0b0;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n.app-container {\n  background-color: var(--dark-bg);\n  color: var(--text-white);\n  line-height: 1.6;\n  background-image: \n      radial-gradient(circle at 10% 20%, rgba(105, 60, 255, 0.05) 0%, transparent 40%),\n      radial-gradient(circle at 90% 80%, rgba(140, 111, 255, 0.05) 0%, transparent 40%);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Header Styles */\nheader {\n  padding: 1.5rem 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\nnav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-white);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.logo-icon {\n  background: linear-gradient(135deg, var(--accent-purple-darker), var(--accent-purple));\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  box-shadow: 0 0 15px rgba(140, 111, 255, 0.3);\n}\n\n.nav-btn {\n  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));\n  color: white;\n  font-weight: 600;\n  padding: 0.6rem 1.2rem;\n  border-radius: 8px;\n  text-decoration: none;\n  transition: all 0.2s;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 0 10px rgba(140, 111, 255, 0.4);\n}\n\n.nav-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 20px rgba(140, 111, 255, 0.6);\n}\n\n/* Hero Section */\n.hero {\n  padding: 5rem 0 5rem;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle at center, rgba(140, 111, 255, 0.03) 0%, transparent 70%);\n  z-index: -1;\n}\n\n.hero h1 {\n  font-size: 2.8rem;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  background: linear-gradient(135deg, var(--text-white) 0%, #d0c8ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero p {\n  font-size: 1.2rem;\n  color: var(--text-light);\n  max-width: 700px;\n  margin: 0 auto 2.5rem;\n}\n\n/* Hero Email Form */\n.hero-email-form {\n  max-width: 550px;\n  margin: 0 auto 1.5rem;\n  display: flex;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 0 30px rgba(140, 111, 255, 0.15);\n}\n\n.hero-email-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 1rem 1.5rem;\n  font-size: 1rem;\n  color: white;\n  outline: none;\n}\n\n.hero-email-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.hero-submit-btn {\n  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));\n  color: white;\n  font-weight: 600;\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 0 10px rgba(140, 111, 255, 0.3);\n}\n\n.hero-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 20px rgba(140, 111, 255, 0.5);\n}\n\n.hero-privacy {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n/* HIPAA Badge */\n.hipaa-badge {\n  display: inline-flex;\n  align-items: center;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08));\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 30px;\n  padding: 8px 20px;\n  margin: 1.5rem auto 0.5rem;\n  box-shadow: 0 0 25px rgba(140, 111, 255, 0.5);\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.hipaa-badge-form {\n  margin-top: 1.5rem;\n}\n\n.hipaa-badge:hover {\n  box-shadow: 0 0 30px rgba(140, 111, 255, 0.7);\n  transform: translateY(-2px);\n}\n\n.hipaa-badge::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  animation: shimmer 3s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n.hipaa-badge-icon {\n  background: linear-gradient(135deg, var(--accent-purple-darker), var(--accent-purple));\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  box-shadow: 0 0 10px rgba(140, 111, 255, 0.8);\n  font-size: 14px;\n  font-weight: bold;\n  position: relative;\n}\n\n.hipaa-badge-icon::after {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  animation: pulse 2s infinite;\n}\n\n.hipaa-badge-text {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  color: white;\n  font-size: 0.95rem;\n}\n\n/* Feature Cards */\n.features {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin: 4rem 0;\n}\n\n.feature-card {\n  background: linear-gradient(145deg, rgba(40, 40, 80, 0.6), rgba(30, 30, 60, 0.8));\n  border-radius: 16px;\n  padding: 2.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15), 0 0 15px rgba(140, 111, 255, 0.2);\n}\n\n.feature-icon {\n  background: linear-gradient(135deg, rgba(140, 111, 255, 0.2), rgba(140, 111, 255, 0.1));\n  color: var(--accent-purple-lighter);\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 0 20px rgba(140, 111, 255, 0.2);\n  position: relative;\n}\n\n.feature-icon::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: transparent;\n  border: 1px solid rgba(140, 111, 255, 0.3);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  70% {\n    transform: scale(1.1);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n.feature-card h3 {\n  font-size: 1.4rem;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, var(--text-white), #d0c8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.feature-card p {\n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n/* Demo Section */\n.demo {\n  background: linear-gradient(145deg, rgba(40, 40, 80, 0.6), rgba(30, 30, 60, 0.8));\n  border-radius: 20px;\n  padding: 3.5rem;\n  margin: 5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 3.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2), 0 0 20px rgba(140, 111, 255, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.demo::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 70%;\n  height: 70%;\n  background: radial-gradient(circle at center, rgba(140, 111, 255, 0.05) 0%, transparent 70%);\n  z-index: 0;\n}\n\n.demo-content {\n  flex: 1;\n  position: relative;\n  z-index: 1;\n}\n\n.demo-content h2 {\n  font-size: 2.2rem;\n  margin-bottom: 2rem;\n  background: linear-gradient(135deg, var(--text-white), #d0c8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.demo-content p {\n  color: var(--text-light);\n  margin-bottom: 2rem;\n}\n\n.demo-illustration {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 16px;\n  padding: 1.5rem;\n  min-height: 340px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);\n  position: relative;\n  z-index: 1;\n}\n\n.demo-ui-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.demo-ui-bar {\n  background-color: rgba(255,255,255,0.05);\n  height: 35px;\n  border-radius: 8px;\n}\n\n.demo-ui-content {\n  background-color: rgba(255,255,255,0.02);\n  height: 180px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgba(255,255,255,0.3);\n}\n\n.demo-ui-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.demo-ui-button {\n  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));\n  width: 110px;\n  height: 38px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  box-shadow: 0 0 15px rgba(140, 111, 255, 0.4);\n}\n\n.demo-step {\n  display: flex;\n  margin-bottom: 2rem;\n  padding-left: 0.5rem;\n}\n\n.step-number {\n  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));\n  color: white;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1.2rem;\n  font-weight: 600;\n  flex-shrink: 0;\n  box-shadow: 0 0 15px rgba(140, 111, 255, 0.4);\n}\n\n.demo-step p {\n  margin-bottom: 0;\n}\n\n/* Email Collection */\n.email-collection {\n  background: linear-gradient(135deg, #7247ff 0%, #a16bff 100%);\n  border-radius: 20px;\n  padding: 4rem;\n  text-align: center;\n  margin: 5rem 0;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15), 0 0 30px rgba(140, 111, 255, 0.3);\n}\n\n.email-collection::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%);\n  z-index: 0;\n}\n\n.email-collection h2 {\n  font-size: 2.4rem;\n  margin-bottom: 1.5rem;\n  position: relative;\n  z-index: 1;\n}\n\n.email-collection p {\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 600px;\n  margin: 0 auto 2.5rem;\n  font-size: 1.1rem;\n  position: relative;\n  z-index: 1;\n}\n\n.email-form {\n  max-width: 500px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.email-input {\n  background-color: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 10px;\n  padding: 1.2rem 1.5rem;\n  font-size: 1rem;\n  color: white;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.email-input::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.email-input:focus {\n  border-color: rgba(255, 255, 255, 0.8);\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);\n}\n\n.submit-btn {\n  background: white;\n  color: var(--accent-purple-darker);\n  font-weight: 600;\n  padding: 1.2rem;\n  border: none;\n  border-radius: 10px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);\n}\n\n.submit-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.3);\n}\n\n.privacy-note {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 1rem;\n}\n\n/* Testimonials */\n.testimonials {\n  margin: 5rem 0;\n}\n\n.testimonials h2 {\n  text-align: center;\n  font-size: 2.2rem;\n  margin-bottom: 3rem;\n  background: linear-gradient(135deg, var(--text-white), #d0c8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.testimonial-card {\n  background: linear-gradient(145deg, rgba(40, 40, 80, 0.6), rgba(30, 30, 60, 0.8));\n  border-radius: 16px;\n  padding: 2.5rem;\n  margin-bottom: 2.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s;\n  position: relative;\n  overflow: hidden;\n}\n\n.testimonial-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15), 0 0 15px rgba(140, 111, 255, 0.2);\n}\n\n.testimonial-card::before {\n  content: \"\\201C\";\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  font-size: 5rem;\n  color: rgba(140, 111, 255, 0.1);\n  font-family: Georgia, serif;\n  line-height: 1;\n}\n\n.testimonial-content {\n  font-size: 1.1rem;\n  color: var(--text-light);\n  margin-bottom: 1.8rem;\n  line-height: 1.8;\n  position: relative;\n  z-index: 1;\n  padding-left: 1rem;\n}\n\n.testimonial-author {\n  display: flex;\n  align-items: center;\n}\n\n.author-avatar {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent-purple), var(--accent-purple-lighter));\n  margin-right: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 600;\n  box-shadow: 0 0 15px rgba(140, 111, 255, 0.3);\n}\n\n.author-info h4 {\n  font-size: 1.1rem;\n  margin-bottom: 0.3rem;\n}\n\n.author-info p {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n/* Footer */\nfooter {\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  padding: 2.5rem 0;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n/* Glowing button effect */\n.glow-btn {\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.glow-btn::after {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.3) 0%, transparent 80%);\n  opacity: 0;\n  transition: opacity 0.3s;\n  z-index: -1;\n  transform: scale(0.5);\n}\n\n.glow-btn:hover::after {\n  opacity: 0.3;\n  transform: scale(1);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .hero h1 {\n    font-size: 2.2rem;\n  }\n  \n  .hero-email-form {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n  \n  .hero-submit-btn {\n    width: 100%;\n  }\n  \n  .demo {\n    flex-direction: column;\n    padding: 2rem;\n  }\n  \n  .email-collection {\n    padding: 2.5rem 1.5rem;\n  }\n  \n  .feature-card, .testimonial-card {\n    padding: 2rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-container": `HomeScreen_app-container__Fqevn`,
	"container": `HomeScreen_container__Hzmd0`,
	"logo": `HomeScreen_logo__h9zvs`,
	"logo-icon": `HomeScreen_logo-icon__ElA7K`,
	"nav-btn": `HomeScreen_nav-btn__Vi8Sj`,
	"hero": `HomeScreen_hero__g6a7w`,
	"hero-email-form": `HomeScreen_hero-email-form__Dp37Y`,
	"hero-email-input": `HomeScreen_hero-email-input__KCKrg`,
	"hero-submit-btn": `HomeScreen_hero-submit-btn__A-Vmw`,
	"hero-privacy": `HomeScreen_hero-privacy__y67GE`,
	"hipaa-badge": `HomeScreen_hipaa-badge__0Ln4d`,
	"hipaa-badge-form": `HomeScreen_hipaa-badge-form__0W9hf`,
	"shimmer": `HomeScreen_shimmer__cOI-2`,
	"hipaa-badge-icon": `HomeScreen_hipaa-badge-icon__XooAb`,
	"pulse": `HomeScreen_pulse__jhb+w`,
	"hipaa-badge-text": `HomeScreen_hipaa-badge-text__Fvv4N`,
	"features": `HomeScreen_features__ARRmd`,
	"feature-card": `HomeScreen_feature-card__MbAX8`,
	"feature-icon": `HomeScreen_feature-icon__q9D29`,
	"demo": `HomeScreen_demo__SHuwi`,
	"demo-content": `HomeScreen_demo-content__c+yzC`,
	"demo-illustration": `HomeScreen_demo-illustration__ZDz5H`,
	"demo-ui-container": `HomeScreen_demo-ui-container__bzlZw`,
	"demo-ui-bar": `HomeScreen_demo-ui-bar__j9NnG`,
	"demo-ui-content": `HomeScreen_demo-ui-content__Z2W8V`,
	"demo-ui-actions": `HomeScreen_demo-ui-actions__yioFe`,
	"demo-ui-button": `HomeScreen_demo-ui-button__XGaYD`,
	"demo-step": `HomeScreen_demo-step__6HtkX`,
	"step-number": `HomeScreen_step-number__jKrMs`,
	"email-collection": `HomeScreen_email-collection__sxGda`,
	"email-form": `HomeScreen_email-form__qgWEC`,
	"email-input": `HomeScreen_email-input__5r59O`,
	"submit-btn": `HomeScreen_submit-btn__CaemG`,
	"privacy-note": `HomeScreen_privacy-note__Xya45`,
	"testimonials": `HomeScreen_testimonials__BjIeG`,
	"testimonial-card": `HomeScreen_testimonial-card__CvLeQ`,
	"testimonial-content": `HomeScreen_testimonial-content__sEWn6`,
	"testimonial-author": `HomeScreen_testimonial-author__RHghx`,
	"author-avatar": `HomeScreen_author-avatar__gaow7`,
	"author-info": `HomeScreen_author-info__oPkpo`,
	"glow-btn": `HomeScreen_glow-btn__-ckj3`
};
export default ___CSS_LOADER_EXPORT___;
